module.exports = __webpack_public_path__ + "assets/media/eye-off.dc25cc87.svg";